module.exports = __webpack_public_path__ + "static/media/widgetImage123px.82e3bf6a.svg";